import { mapActions, mapGetters } from 'vuex'
import { vuexTypes } from '@vuex/types'
import { normalize } from '@utils/math.util'
import { ROUNDING_MODES } from '@const'
import { GREY_ASSETS } from '@utils/consts'

export default {
  computed: {
    ...mapGetters([
      vuexTypes.cryptoPrecision,
      vuexTypes.fiatPrecision,
      vuexTypes.cryptoCurrencies
    ])
  },
  methods: {
    ...mapActions({
      loadConfig: vuexTypes.GET_SERVER_CONFIG
    }),
    roundCurrency (val = 0, currency = 'SANS', direction = true) {
      const currencys = [...this.cryptoCurrencies, ...GREY_ASSETS]
      const precision = currencys.indexOf(currency) !== -1
        ? Math.log10(this.cryptoPrecision)
        : Math.log10(this.fiatPrecision)
      return normalize(val, precision, direction ? ROUNDING_MODES.ROUND_FLOOR : ROUNDING_MODES.ROUND_CEIL)
    },
    roundCurrency2 (input) {
      let num = parseFloat(input)
      let formatted = num.toFixed(6)
      let trimmed = parseFloat(formatted).toString()
      if (!trimmed.includes('.')) {
        trimmed += '.00'
      } else {
        let parts = trimmed.split('.')
        if (parts[1].length < 2) {
          trimmed += '0'.repeat(2 - parts[1].length)
        }
      }
      return trimmed
    },
    roundCurrency3 (input) {
      let num = parseFloat(input)
      let formatted = num.toFixed(6)
      let trimmed = parseFloat(formatted).toString()
      if (!trimmed.includes('.')) {
        trimmed += '.0'
      }
      return trimmed
    }
  }
}



// WEBPACK FOOTER //
// ./src/vue/common/mixins/currency.round.mixin.js